
export const GET_CARD_LIST = 'GET_CARD_LIST';

export const getCardList = (cardList, status) => ({
    type: GET_CARD_LIST,
    cardList,
    status
});
